import { Autocomplete, Grid, TextField, Chip } from '@mui/material';
import ConsultantAutoComplete from '@src/components/consultant/ConsutlantAutoComplete';
import ProcedureAutoComplete from '@src/components/procedure/ProcedureAutoComplete';
import SpecialityAutoComplete from '@src/components/speciality/SpecialityAutoComplete';
import UserControlledAutoComplete from '@src/components/user/UserControlledAutoComplete';
import { MigrationStatus } from '@src/constants/MigrationStatus';
import { Control, Controller } from 'react-hook-form';

interface Props {
  control: Control<any>;
  consultantId: string | null;
  procedureId: string | null;
  setConsultantId(id: string | null): void;
  setProcedureId(id: string | null): void;
}

const statuses = [
  { id: MigrationStatus.Pending, name: 'Pending', checked: false },
  { id: MigrationStatus.InProgress, name: 'In progress', checked: false },
  { id: MigrationStatus.Query, name: 'Query', checked: false },
  {
    id: MigrationStatus.InApproval,
    name: 'In Approval',
    checked: false,
  },
  { id: MigrationStatus.Complete, name: 'Complete', checked: false },
];

function Filter({
  control,
  consultantId,
  procedureId,
  setConsultantId,
  setProcedureId,
}: Props) {
  return (
    <Grid container spacing={2} sx={(theme) => ({ padding: theme.spacing(3) })}>
      <Grid item xs={12} sm={6} md={2.4}>
        <Controller
          name="statuses"
          control={control}
          render={({ field }) => (
            <Autocomplete
              {...field}
              options={statuses}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              multiple
              value={field.value || []}
              onChange={(_, newValue) => field.onChange(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Statuses" variant="standard" />
              )}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <UserControlledAutoComplete
          control={control}
          name="userId"
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <ConsultantAutoComplete
          onSelection={setConsultantId}
          selectedId={consultantId}
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <SpecialityAutoComplete
          control={control}
          name="specialityId"
          variant="standard"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2.4}>
        <ProcedureAutoComplete
          onSelection={setProcedureId}
          selectedId={procedureId}
          variant="standard"
        />
      </Grid>
    </Grid>
  );
}

export default Filter;
